import { api } from '../../lib/api'

export const FINISH_TUTORIAL_SUCCESS = 'FINISH_TUTORIAL_SUCCESS'
export const FINISH_TUTORIAL_FAILED = 'FINISH_TUTORIAL_FAILED'

export const finishTutorial = function () {
  return function (dispatch) {
    api.finishTutorial().then(finishTutorialResponse => {
      dispatch({
        type: FINISH_TUTORIAL_SUCCESS,
        payload: finishTutorialResponse
      })
    }).catch(error => {
      dispatch({
        type: FINISH_TUTORIAL_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/finish-tutorial.js